import { combineReducers } from "redux";
import OpenInterest from "./OpenInterestAnalysis/OpenInterestReducerManager";
import drivingMarket from "./DrivingMarket/drivingMarketReducer";
import futureSpotReducer from "./futureSpot";
import marketToday from "./marketTodayReducer";
import createNamedWrapperReducer from "../../Common/Reducers/wrapperReducer";
import { FnoBanEnum, } from "@adapters/features/Markets/Common/action-interface/fnoBan";
import fnoBan from "../../Common/Reducers/fnoBan";
export default combineReducers({
    drivingMarket,
    OpenInterest,
    futureSpotReducer,
    marketToday,
    fnoBan: createNamedWrapperReducer(fnoBan, FnoBanEnum.FU),
});
